<template>
  <v-progress-linear
    v-if="!loaded"
    indeterminate
    height="10"
  ></v-progress-linear>
</template>

<script>
import { environment } from "../environment/environment.js";
export default {
  name: "Home",
  data() {
    return {
      environment: environment,
      generalExApplicationEx: {},
      session: null,
      loaded: false,
    };
  },
  methods: {
    setAll() {
      if (this.generalExApplicationEx.rootApp) {
        this.goToApplication(this.generalExApplicationEx.rootApp);
      } else {
        if (this.session.loggedIn) {
          this.goToMain();
        } else {
          this.goToLogin();
        }
      }
    },

    loadHome() {
      this.generalExApplicationEx = {};
      this.loaded = false;
      this.apiGetGeneralApplication({})
        .then((dataRes) => {
          this.generalExApplicationEx = dataRes.data;
          this.loaded = true;
          this.setAll();
        })
        .catch((errorRes) => {
          this.clearSession();
          this.clearFrameworkSession();
          if (errorRes.response.status == 403) {
            this.launch();
          } else {
            this.goToErrorServiceUnavaliable({});
          }
        });
    },

    launch() {
      this.validateFrameworkSession()
        .then(() => {
          this.session = this.loadSession();
          this.loadHome();
        })
        .catch(() => {
          this.goToErrorUnauthorized({});
        });
    },
  },

  created() {
    this.launch();
  },
};
</script>
